import { render, staticRenderFns } from "./Datatables.vue?vue&type=template&id=30558da0&"
import script from "./Datatables.vue?vue&type=script&lang=js&"
export * from "./Datatables.vue?vue&type=script&lang=js&"
import style0 from "./Datatables.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports